<h1 id="step-heading" class="step-heading">
  <%= I18n.visit.heading %>
</h1>

<div class="step-form">
  <div class="provider-type-callout-container"></div>
  <div class="slot-message-callout-container"></div>
  <div class="returning-patient-field"></div>
  <div class="visit-type-field"></div>
  <div class="age-range-field"></div>
  <div class="age-range-callout-container"></div>
  <div class="visit-type-rules-field"></div>
  <div class="no-matching-visit-type-callout-container"></div>
  <div class="slot-taken-callout-container"></div>
  <div class="slot-reselector-container"></div>
  <div class="slot-field"></div>
  <div class="location-during-visit-field"></div>
  <div class="not-licensed-for-location-callout-container"></div>
</div>
